import React from "react";
import styles from "./styles.module.css";

const RescheduleModal = ({ setRescheduleModal, width }) => {
  const [page, setPage] = React.useState("1");

  const closeAndReset = () => {
    setRescheduleModal(false);
    setPage("1");
  };

  return (
    <div className={styles.modalBackdrop}>
      <div className={styles.modal} style={{ width: '600px' }}>
        <div
          className={styles.closeBtn}
          onClick={closeAndReset}
        >
          <i className="fas fa-close"></i>
        </div>
        <h2 className={styles.modalHeading}>Request to Reschedule</h2>

        <div className={styles.modalBody}>
          {page === "1" && <Page1 setPage={setPage} setRescheduleModal={setRescheduleModal} />}
          {page === "1A" && <Page1A setRescheduleModal={setRescheduleModal} setPage={setPage} />}
          {page === "1B" && <Page1B setRescheduleModal={setRescheduleModal} setPage={setPage} />}
        </div>
      </div>
    </div>
  );
};

const Page1 = ({ setPage, setRescheduleModal }) => (
  <form onSubmit={(e) => { e.preventDefault(); setPage("1A"); }}>
    <div className={styles.summaryBox}>
      <p style={{ margin: 0 }}>You are about to request a new time for this session. A notification will be sent to the student.</p>
    </div>

    <div className={styles.reasonArea}>
      <label>Message to Student</label>
      <textarea
        rows="4"
        placeholder="Please explain why you are requesting to reschedule..."
        required
      />
    </div>

    <div className={styles.actionArea}>
      <button
        type="button"
        className={styles.secondaryBtn}
        onClick={() => setRescheduleModal(false)}
      >
        Cancel
      </button>
      <button
        type="submit"
        className={styles.primaryBtn}
      >
        Next: Suggest Time
      </button>
    </div>
  </form>
);

const Page1A = ({ setRescheduleModal, setPage }) => (
  <>
    <div className={styles.summaryBox} style={{ background: '#f0f9ff', borderColor: '#bae6fd' }}>
      <div style={{ fontWeight: '800', color: '#0369a1', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '8px' }}>
        <i className="fas fa-clock"></i> Reschedule Suggestion
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '0.75rem', color: '#64748b', textTransform: 'uppercase', fontWeight: '700' }}>Current</div>
          <div style={{ fontSize: '1.25rem', fontWeight: '800', color: '#1e293b' }}>02:00 PM</div>
          <div style={{ fontSize: '0.875rem', color: '#475569' }}>Jan 02, 2021</div>
        </div>

        <i className="fas fa-long-arrow-alt-right" style={{ color: '#0ea5e9', fontSize: '1.5rem' }}></i>

        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '0.75rem', color: '#0369a1', textTransform: 'uppercase', fontWeight: '700' }}>Suggested</div>
          <div style={{ fontSize: '1.25rem', fontWeight: '800', color: '#0369a1' }}>05:30 PM</div>
          <div style={{ fontSize: '0.875rem', color: '#0369a1' }}>Jan 03, 2021</div>
        </div>
      </div>
    </div>

    <div className={styles.actionArea}>
      <button
        className={styles.secondaryBtn}
        onClick={() => setPage("1")}
      >
        Go Back
      </button>
      <button
        className={styles.primaryBtn}
        onClick={() => { alert("Reschedule suggestion sent!"); setRescheduleModal(false); }}
      >
        Send Suggestion
      </button>
    </div>
  </>
);

const Page1B = ({ setRescheduleModal, setPage }) => (
  <>
    <div className={styles.summaryBox}>
      <p style={{ textAlign: 'center' }}>Calendar functionality will be integrated here.</p>
    </div>
    <div className={styles.actionArea}>
      <button
        className={styles.secondaryBtn}
        onClick={() => setPage("1")}
      >
        Back
      </button>
      <button
        className={styles.primaryBtn}
        onClick={() => setRescheduleModal(false)}
      >
        Finish
      </button>
    </div>
  </>
);

export default RescheduleModal;
